webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);


var firebaseConfig = {
	apiKey: "AIzaSyDehA5ITh0QsR8VL0xcaMmmiI7sQee-5m0",
	authDomain: "m-walerski.firebaseapp.com",
	databaseURL: "https://m-walerski.firebaseio.com",
	storageBucket: "m-walerski.appspot.com",
	messagingSenderId: "815071267600"
};

var app = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(firebaseConfig);
var db = app.database();
var storage = app.storage().ref();

/* harmony default export */ __webpack_exports__["a"] = ({
	PROJECT_NAME: "Medhi Walerski",

	getEmptyPage: function getEmptyPage() {
		return {
			title: '',
			slug: '',
			created: '',
			updated: '',
			css_class: '',
			position: 0,
			type: 'basic',
			published: false,
			locked: false
		};
	},

	getEmptySlice: function getEmptySlice() {
		return {
			name: '',
			content: '',
			visible: true,
			css_class: '',
			locked: false
		};
	},

	getEmptyFile: function getEmptyFile() {
		return {
			name: '',
			url: ''
		};
	},

	db: db,
	storage: storage,

	errorMessages: {
		SLUG_EXIST: 'Page slug already exist',
		PAGE_ADDED: 'Page added',
		PAGE_EDITED: 'Page edited',
		SLICE_ADDED: 'Slice added',
		SLICE_EDITED: 'Slice edited',
		SLICE_REMOVED: 'Slice removed',
		LOADING: 'Loading',
		ERROR: 'Error while update, please retry.'
	}
});

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(207)
__webpack_require__(208)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(261),
  /* scopeId */
  "data-v-55cbe936",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(202)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(257),
  /* scopeId */
  "data-v-235c4208",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(198)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(150),
  /* template */
  __webpack_require__(255),
  /* scopeId */
  "data-v-1821e482",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(209)
__webpack_require__(210)
__webpack_require__(211)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(262),
  /* scopeId */
  "data-v-5a82feac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_back_home_HomeBack__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_back_home_HomeBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_back_home_HomeBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_front_PageList__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_front_PageList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_front_PageList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_back_page_edit_PageEdit__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_back_page_edit_PageEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_back_page_edit_PageEdit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_front_DynamicPage__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_front_DynamicPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_front_DynamicPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_front_PageView__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_front_PageView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_front_PageView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_back_login_Login__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_back_login_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_back_login_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_front_Front__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_front_Front___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_front_Front__);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_8__components_front_Front___default.a,
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_6__components_front_PageView___default.a,
      props: { slug: 'home' }
    }, {
      path: '/work',
      component: __WEBPACK_IMPORTED_MODULE_3__components_front_PageList___default.a
    }, {
      path: '/work/:slug',
      component: __WEBPACK_IMPORTED_MODULE_5__components_front_DynamicPage___default.a
    }, {
      path: '/about',
      component: __WEBPACK_IMPORTED_MODULE_6__components_front_PageView___default.a,
      props: { slug: 'about' }
    }, {
      path: '/contact',
      component: __WEBPACK_IMPORTED_MODULE_6__components_front_PageView___default.a,
      props: { slug: 'contact' }
    }]
  }, {
    path: '/admin',
    component: __WEBPACK_IMPORTED_MODULE_2__components_back_home_HomeBack___default.a
  }, {
    path: '/admin/edit/:page_id',
    component: __WEBPACK_IMPORTED_MODULE_4__components_back_page_edit_PageEdit___default.a
  }, {
    path: '/login',
    component: __WEBPACK_IMPORTED_MODULE_7__components_back_login_Login___default.a
  }]
}));

/***/ }),
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(212)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(148),
  /* template */
  __webpack_require__(263),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 147 */,
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      title: ''
    };
  },

  filters: {
    truncate: function truncate(string, value) {
      return string.substring(0, value) + '...';
    }
  }
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'header-back',
	data: function data() {
		return {
			title: __WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].PROJECT_NAME,
			email: ''
		};
	},

	methods: {
		signOut: function signOut() {
			var scope = this;
			__WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().signOut().then(function () {
				scope.$router.push('/login');
			}, function (error) {
				console.error('Sign Out Error', error);
			});
		}
	},
	created: function created() {
		var user = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser;
		if (user) {
			this.email = user.email;
		} else {
			this.$router.push('/login');
		}
	}
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'slug-field',
	props: ['stringToSlug'],
	data: function data() {
		return {
			slug: ''
		};
	},

	methods: {
		slugify: function slugify(str) {
			str = str.replace(/^\s+|\s+$/g, '');
			str = str.toLowerCase();

			var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
			var to = "aaaaeeeeiiiioooouuuunc------";
			for (var i = 0, l = from.length; i < l; i++) {
				str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
			}

			str = str.replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');

			return str;
		}
	},
	watch: {
		stringToSlug: function stringToSlug() {
			this.slug = this.slugify(this.stringToSlug);
		},
		slug: function slug() {
			this.$emit('update', this.slug);
		}
	}
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_back_home_PageCreate__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_back_home_PageCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_back_home_PageCreate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_back_home_PageList__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_back_home_PageList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_back_home_PageList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_back_HeaderBack__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_back_HeaderBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_back_HeaderBack__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home-back',
  data: function data() {
    return {
      msg: ''
    };
  },

  components: {
    PageCreate: __WEBPACK_IMPORTED_MODULE_0__components_back_home_PageCreate___default.a,
    PageList: __WEBPACK_IMPORTED_MODULE_1__components_back_home_PageList___default.a,
    HeaderBack: __WEBPACK_IMPORTED_MODULE_2__components_back_HeaderBack___default.a
  }
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_back_field_SlugField__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_back_field_SlugField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_back_field_SlugField__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'page-create',

	firebase: {
		pages: __WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].db.ref('pages')
	},

	components: {
		SlugField: __WEBPACK_IMPORTED_MODULE_3__components_back_field_SlugField___default.a
	},

	data: function data() {
		return {
			newPage: __WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].getEmptyPage(),
			slug: '',
			stringToSlug: '',
			title: ''
		};
	},

	methods: {
		updatePageSlug: function updatePageSlug(newSlug) {
			this.slug = newSlug;
		},
		addPage: function addPage() {
			var newPage = this.newPage;

			newPage.title = this.title;
			newPage.slug = this.slug;

			newPage.created = newPage.updated = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('x');

			this.$firebaseRefs.pages.push(newPage);

			newPage.title = newPage.slug = newPage.created = newPage.updated = this.slug = this.title = '';
			__WEBPACK_IMPORTED_MODULE_1_toastr___default.a.success(__WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].errorMessages.PAGE_ADDED);
		},
		validate: function validate() {
			var scope = this;

			this.$firebaseRefs.pages.orderByChild("slug").equalTo(this.slug).once('value').then(function (snapshot) {
				var exists = snapshot.exists();
				if (exists) __WEBPACK_IMPORTED_MODULE_1_toastr___default.a.error(__WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].errorMessages.SLUG_EXIST);else scope.addPage();
			});
		}
	},
	computed: {
		active: function active() {
			return this.slug != '';
		}
	},
	watch: {
		title: {
			handler: function handler() {
				this.stringToSlug = this.title;
			},

			sync: true
		}
	}
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page-list',

  firebase: {
    pages: __WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].db.ref('pages')
  },

  data: function data() {
    return {
      msg: __WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].test
    };
  },

  methods: {
    clonePage: function clonePage(page) {
      var newPage = {};
      var newRef = this.$firebaseRefs.pages.push(newPage);

      this.$firebaseRefs.pages.child(page['.key']).once('value', function (snap) {
        var pageVal = snap.val();

        pageVal.created = pageVal.updated = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('x');
        pageVal.files = [];
        pageVal.slug = pageVal.slug + "-c";
        newRef.set(pageVal, function (error) {
          if (error && typeof console !== 'undefined' && console.error) {
            console.error(error);
          }
        });
      });
    },
    editPage: function editPage(page) {

      this.$router.push('/admin/edit/' + page['.key']);
    },
    removePage: function removePage(page) {
      this.$firebaseRefs.pages.child(page['.key']).remove();
      __WEBPACK_IMPORTED_MODULE_1_toastr___default.a.success('Page removed successfully');
    }
  },
  created: function created() {},
  computed: {
    active: function active() {
      return this.slug != '';
    }
  }
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  data: function data() {
    return {
      title: __WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].PROJECT_NAME,
      email: '',
      pwd: '',
      error: ''
    };
  },

  methods: {
    login: function login() {
      var scope = this;
      var credential = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().signInWithEmailAndPassword(this.email, this.pwd).then(function () {
        scope.$router.push('/admin');
      }).catch(function (error) {
        console.log(error);

        var errorCode = error.code;
        scope.error = error.message;
      });;
    }
  },
  created: function created() {
    $('#sub').tooltip();
  }
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_toastr__);





var pageFileRef;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'media-manager',
  props: ['pageKey'],
  data: function data() {
    return {
      tmpFileData: {},
      currentFile: __WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].getEmptyFile(),
      files: []
    };
  },

  methods: {
    addFile: function addFile() {
      var scope = this;
      var currentFile = this.currentFile;

      currentFile.name = this.tmpFileData.name;

      var fileStorageRef = __WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].storage.child(currentFile.name);
      var oldTimeout = __WEBPACK_IMPORTED_MODULE_1_toastr___default.a.options.timeOut;

      __WEBPACK_IMPORTED_MODULE_1_toastr___default.a.options.timeOut = 0;
      __WEBPACK_IMPORTED_MODULE_1_toastr___default.a.info('File is uploading... Please wait.');

      fileStorageRef.putString(this.tmpFileData.data, 'data_url').then(function (snapshot) {
        currentFile.url = snapshot.downloadURL;
        pageFileRef.push(currentFile);
        __WEBPACK_IMPORTED_MODULE_1_toastr___default.a.options.timeOut = oldTimeout;
        __WEBPACK_IMPORTED_MODULE_1_toastr___default.a.clear();
        __WEBPACK_IMPORTED_MODULE_1_toastr___default.a.success('File uploaded successfully');

        currentFile = __WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].getEmptyFile();
      });
    },

    removeFile: function removeFile(file) {
      var fileToRemoveRef = __WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].storage.child(file.name);

      fileToRemoveRef.delete().then(function () {
        pageFileRef.child(file.key).remove();
        __WEBPACK_IMPORTED_MODULE_1_toastr___default.a.success('File removed successfully');
      }).catch(function (error) {});
    },

    copyToClipboard: function copyToClipboard(file) {
      var url = file.url;
      var $temp = $("<input>");
      $("body").append($temp);
      $temp.val(url).select();
      document.execCommand("copy");
      $temp.remove();
    },

    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createFile(files[0]);
    },
    createFile: function createFile(fileData) {
      var _this = this;

      var reader = new FileReader();
      this.tmpFileData = {};

      reader.onload = function (e) {
        _this.tmpFileData.name = fileData.name;
        _this.tmpFileData.data = e.target.result;
      };
      reader.readAsDataURL(fileData);
    }
  },

  created: function created() {
    var scope = this;
    pageFileRef = __WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].db.ref('pages/' + this.pageKey + '/files');
    pageFileRef.on('value', function (filesSnapshot) {
      scope.files = [];

      filesSnapshot.forEach(function (snapshot) {
        var object = snapshot.val();
        object.key = snapshot.key;
        scope.files.push(object);
      });
    });
  }
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_back_field_SlugField__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_back_field_SlugField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_back_field_SlugField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_back_page_edit_SliceManager__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_back_page_edit_SliceManager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_back_page_edit_SliceManager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_back_page_edit_FileManager__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_back_page_edit_FileManager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_back_page_edit_FileManager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_back_HeaderBack__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_back_HeaderBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_back_HeaderBack__);










/* harmony default export */ __webpack_exports__["default"] = ({
		name: 'page-edit',

		firebase: {
				pages: __WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].db.ref('pages')
		},

		data: function data() {
				return {
						key: this.$route.params.page_id,
						currentPage: __WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].getEmptyPage(),
						title: '',
						stringToSlug: ''
				};
		},

		components: {
				HeaderBack: __WEBPACK_IMPORTED_MODULE_6__components_back_HeaderBack___default.a, SlugField: __WEBPACK_IMPORTED_MODULE_3__components_back_field_SlugField___default.a, SliceManager: __WEBPACK_IMPORTED_MODULE_4__components_back_page_edit_SliceManager___default.a, FileManager: __WEBPACK_IMPORTED_MODULE_5__components_back_page_edit_FileManager___default.a
		},

		created: function created() {
				var scope = this;
				__WEBPACK_IMPORTED_MODULE_1_toastr___default.a.info(__WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].errorMessages.LOADING);
				this.$firebaseRefs.pages.child(this.key).once('value').then(function (snapshot) {
						var object = snapshot.val();
						scope.currentPage = object;

						scope.title = scope.currentPage.title;

						scope.stringToSlug = scope.currentPage.slug;
						__WEBPACK_IMPORTED_MODULE_1_toastr___default.a.clear();
				});
		},

		methods: {
				updatePageSlug: function updatePageSlug(newSlug) {
						this.currentPage.slug = newSlug;
				},
				editPage: function editPage() {
						this.currentPage.updated = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('x');
						this.$firebaseRefs.pages.child(this.key).set(this.currentPage);
						__WEBPACK_IMPORTED_MODULE_1_toastr___default.a.success(__WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].errorMessages.PAGE_EDITED);
				},
				validate: function validate() {
						var scope = this;

						this.$firebaseRefs.pages.orderByChild("slug").equalTo(this.currentPage.slug).once('value').then(function (snapshot) {
								var exists = snapshot.exists();
								var isCurrentPage = false;

								snapshot.forEach(function (childSnapshot) {
										if (childSnapshot.key == scope.key) isCurrentPage = true;
								});
								if (exists && !isCurrentPage) __WEBPACK_IMPORTED_MODULE_1_toastr___default.a.error(__WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].errorMessages.SLUG_EXIST);else scope.editPage();
						});
				},
				updatePageData: function updatePageData(page) {
						this.currentPage = page;
				}
		},

		watch: {
				title: {
						handler: function handler() {
								this.currentPage.title = this.title;
								this.stringToSlug = this.title;
						},

						sync: true
				}
		}

});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_back_page_edit_modal_ModalSlice__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_back_page_edit_modal_ModalSlice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_back_page_edit_modal_ModalSlice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_back_page_edit_modal_ModalImgSlice__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_back_page_edit_modal_ModalImgSlice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_back_page_edit_modal_ModalImgSlice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_back_page_edit_modal_ModalQuote__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_back_page_edit_modal_ModalQuote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_back_page_edit_modal_ModalQuote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_back_page_edit_modal_ModalCredits__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_back_page_edit_modal_ModalCredits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_back_page_edit_modal_ModalCredits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_toastr__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_toastr__);










var sliceRef;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'slice-manager',
  props: ['pageKey'],
  firebase: {
    pages: __WEBPACK_IMPORTED_MODULE_4__global__["a" /* default */].db.ref('pages')
  },
  components: {
    ModalSlice: __WEBPACK_IMPORTED_MODULE_0__components_back_page_edit_modal_ModalSlice___default.a, ModalImgSlice: __WEBPACK_IMPORTED_MODULE_1__components_back_page_edit_modal_ModalImgSlice___default.a, ModalQuote: __WEBPACK_IMPORTED_MODULE_2__components_back_page_edit_modal_ModalQuote___default.a, ModalCredits: __WEBPACK_IMPORTED_MODULE_3__components_back_page_edit_modal_ModalCredits___default.a
  },
  data: function data() {
    return {
      sliceKey: false,
      modalTitle: '',
      currentSlice: __WEBPACK_IMPORTED_MODULE_4__global__["a" /* default */].getEmptySlice(),

      draggedSlices: [],

      slices: []
    };
  },

  methods: {
    saveSlice: function saveSlice(modalName) {
      if (!this.sliceKey) {
        var scope = this;

        this.currentSlice.index = this.draggedSlices.length;
        sliceRef.push(this.currentSlice, function (error) {
          scope.refreshSliceView();
          scope.resetSlice();
        });
        __WEBPACK_IMPORTED_MODULE_5_toastr___default.a.success(__WEBPACK_IMPORTED_MODULE_4__global__["a" /* default */].errorMessages.SLICE_ADDED);
      } else {
        sliceRef.child(this.sliceKey).set(this.currentSlice, function (error) {
          scope.refreshSliceView();
          scope.resetSlice();
        });
        __WEBPACK_IMPORTED_MODULE_5_toastr___default.a.success(__WEBPACK_IMPORTED_MODULE_4__global__["a" /* default */].errorMessages.SLICE_EDITED);
      }

      var modalToClose = [];
      modalToClose['modal-slice'] = 'sliceModal';
      modalToClose['modal-img-slice'] = 'sliceImgModal';
      modalToClose['modal-quote'] = 'sliceQuoteModal';
      modalToClose['modal-credits'] = 'sliceCreditsModal';
      $('#' + modalToClose[modalName]).modal('toggle');
      this.dispatchUpdatedPage();
    },
    resetSlice: function resetSlice() {
      this.sliceKey = false;
      this.modalTitle = 'New Slice';
      this.currentSlice = __WEBPACK_IMPORTED_MODULE_4__global__["a" /* default */].getEmptySlice();
    },
    editSlice: function editSlice(slice, sliceKey) {
      this.currentSlice = slice;
      this.sliceKey = sliceKey;
      this.modalTitle = 'Edit Slice: ' + sliceKey;
      this.content = slice.content;
      $('#sliceModal').modal('toggle');
    },
    removeSlice: function removeSlice(slice, sliceKey) {
      var scope = this;
      sliceRef.child(sliceKey).remove(function (error) {
        scope.draggedSlices.splice(scope.draggedSlices.indexOf(sliceKey), 1);
        scope.refreshSliceView();
      });
      __WEBPACK_IMPORTED_MODULE_5_toastr___default.a.success(__WEBPACK_IMPORTED_MODULE_4__global__["a" /* default */].errorMessages.SLICE_REMOVED);
      this.dispatchUpdatedPage();
    },
    onDragSlice: function onDragSlice(event) {
      this.draggedSlices.splice(event.newIndex, 0, this.draggedSlices.splice(event.oldIndex, 1)[0]);

      this.updateDragIndex(false);
    },
    updateDragIndex: function updateDragIndex(updateView) {
      var scope = this;
      var updates = {};
      $('#slices .handle').addClass('disabled');
      for (var i = 0; i < this.draggedSlices.length; i++) {
        var sliceKey = this.draggedSlices[i];
        var path = this.pageKey + '/slices/' + sliceKey + '/index';
        updates[path] = i;

        for (var j = 0; j < this.slices.length; j++) {
          if (this.slices[j].sliceKey == sliceKey) this.slices[j].index = i;
        };
      };
      __WEBPACK_IMPORTED_MODULE_4__global__["a" /* default */].db.ref('pages').update(updates, function (error) {
        if (updateView) scope.refreshSliceView();else $('#slices .handle').removeClass('disabled');
      });
    },
    dispatchUpdatedPage: function dispatchUpdatedPage() {
      var scope = this;
      __WEBPACK_IMPORTED_MODULE_4__global__["a" /* default */].db.ref('pages/' + this.pageKey).on('value', function (snapshot) {
        var object = snapshot.val();
        scope.$emit('update', object);
      });
    },
    refreshSliceView: function refreshSliceView() {
      var scope = this;
      scope.slices = [];
      scope.draggedSlices = [];
      sliceRef = __WEBPACK_IMPORTED_MODULE_4__global__["a" /* default */].db.ref('pages/' + this.pageKey + '/slices');

      sliceRef.orderByChild('index').once('value', function (slicesSnapshot) {
        slicesSnapshot.forEach(function (snapshot) {
          var sliceKey = snapshot.key;
          var object = snapshot.val();
          object.sliceKey = sliceKey;
          scope.slices.push(object);
          scope.draggedSlices.push(sliceKey);
        });
      });
    }
  },

  created: function created() {
    this.refreshSliceView();
  }
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_select__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modal-credits',
  props: ['currentSlice', 'modalTitle'],
  data: function data() {
    return {
      subtitle: null,
      currentRole: null,
      currentName: null,
      credits: []
    };
  },

  methods: {
    addCredit: function addCredit() {
      this.credits.push({ role: this.currentRole, name: this.currentName });
      this.currentName = this.currentRole = null;
    },
    saveSlice: function saveSlice() {
      this.currentSlice.name = 'Credits';
      this.currentSlice.css_class = 'credits';
      if (this.subtitle) this.currentSlice.content = '<h3>' + this.subtitle + '</h3>';
      if (this.credits.length) {
        this.currentSlice.content += '<ul>';
        for (var i = 0; i < this.credits.length; i++) {
          var credit = this.credits[i];
          var role = credit.role ? '<b>' + credit.role + '</b>' : '';
          var name = credit.name ? credit.name : '';
          var delim = credit.role && credit.name ? ' ' : '';
          this.currentSlice.content += '<li>' + role + delim + name + '</li>';
        };
        this.currentSlice.content += '</ul>';
      }

      this.$emit('save', 'modal-credits');
    },
    removeCredit: function removeCredit(credit) {
      var index = this.credits.indexOf(credit);
      this.credits.splice(index, 1);
    }
  },
  components: {
    vSelect: __WEBPACK_IMPORTED_MODULE_0_vue_select___default.a
  }
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_select__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modal-img-slice',
  props: ['currentSlice', 'modalTitle'],
  data: function data() {
    return {
      imgUrl: '',
      animation: null,
      position: null
    };
  },

  methods: {
    saveSlice: function saveSlice() {
      this.currentSlice.name = 'Image';
      var pos = this.position ? this.position.value : '';
      var anim = this.animation ? this.animation.value : '';
      if (this.position && this.animation) anim = ' ' + anim;
      this.currentSlice.css_class = pos + anim;
      this.currentSlice.css_style = '';
      this.$emit('save', 'modal-img-slice');
      this.animation = this.position = null;
      this.imgUrl = '';
    },
    onChangeImgUrl: function onChangeImgUrl() {
      this.currentSlice.content = '<img src="' + this.imgUrl + '">';
    }
  },
  components: {
    vSelect: __WEBPACK_IMPORTED_MODULE_0_vue_select___default.a
  }
});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_select__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modal-quote',
  props: ['currentSlice', 'modalTitle'],
  data: function data() {
    return {
      quote: '',
      author: '',
      star: '0'
    };
  },

  methods: {
    saveSlice: function saveSlice() {
      this.currentSlice.name = 'Quote';
      this.currentSlice.content = this.quote;
      if (this.author != '') {
        this.currentSlice.content += '<br>';
        this.currentSlice.content += '<b>' + this.author;
        var nStar = parseInt(this.star);
        if (nStar > 0) this.currentSlice.content += '<span class="space-star"></span>';
        for (var i = 0; i < nStar; i++) {
          this.currentSlice.content += '<span class="star"></span>';
        };
        this.currentSlice.content += '</b>';
      }
      this.currentSlice.css_class = 'quote';
      this.$emit('save', 'modal-quote');
      this.quote = '';
      this.author = '';
      this.star = '0';
    }
  },
  components: {
    vSelect: __WEBPACK_IMPORTED_MODULE_0_vue_select___default.a
  }
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modal-slice',
  props: ['currentSlice', 'modalTitle'],
  data: function data() {
    return {};
  },

  methods: {
    saveSlice: function saveSlice() {
      this.$emit('save', 'modal-slice');
    },
    onChangeContent: function onChangeContent(newContent) {
      this.currentSlice.content = newContent;
    }
  },
  components: {}
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_velocity_animate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_velocity_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_velocity_animate__);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'animated-loader',
	data: function data() {
		return {
			title: __WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].PROJECT_NAME,
			itvGif: null,
			tId: null
		};
	},

	methods: {
		setOverlay: function setOverlay() {

			$('.animated-loader').addClass('overlay');
		},
		unsetOverlay: function unsetOverlay() {

			$('.animated-loader').removeClass('overlay');
			$("#logo").addClass('hide');
		},
		hide: function hide() {
			clearTimeout(this.tId);
			$('.animated-loader').addClass('hide');
		},
		close: function close() {
			var scope = this;
			$('body').css('position', 'static');

			__WEBPACK_IMPORTED_MODULE_1_velocity_animate___default()($("#logo"), { opacity: 0 }, { duration: 1000, transition: "easeInOutExpo", complete: function complete() {
					$("#logo-loader").addClass('hide');
					scope.$emit('close');
				} });
		},
		show: function show() {
			this.tId = setTimeout(function () {
				$('.animated-loader').removeClass('hide');
			}, 600);
		},
		startRandomGif: function startRandomGif() {
			$(".spinner-wrapper").removeClass('hide');
			return;
			$('.gif_dance').css('opacity', 0);
			$('.gif_dance').removeClass('hide');
			for (var i = 0; i < 8; i++) {
				this.animateRandomGif(i);
			};
		},
		stopRandomGif: function stopRandomGif() {
			$(".spinner-wrapper").addClass('hide');
			return;
			$('.gif_dance').addClass('hide');
			$('.gif_dance').css('opacity', 0);
		},
		animateRandomGif: function animateRandomGif(id) {
			var domId = "#gif" + id;
			var gif_w = 400;
			var gif_h = Math.round($(window).height() / 7);
			var gif_gap_h = gif_h * id;

			var sidebar_width = $(window).width() * 0.25;
			var ww = $(window).width() - sidebar_width - gif_w;
			var rTop = gif_gap_h;
			var rLeft = sidebar_width + Math.round(Math.random() * ww);
			__WEBPACK_IMPORTED_MODULE_1_velocity_animate___default()($(domId), { top: rTop, left: rLeft, opacity: 0 }, { duration: 0 });
			__WEBPACK_IMPORTED_MODULE_1_velocity_animate___default()($(domId), { opacity: 1 }, { duration: 400, delay: 50 * id, transition: "easeOutExpo", complete: function complete() {} });
		},
		created: function created() {
			$('body').css('position', 'fixed');
		}
	}
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_front_PageView__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_front_PageView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_front_PageView__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'front',
  components: {
    PageView: __WEBPACK_IMPORTED_MODULE_1__components_front_PageView___default.a
  },
  data: function data() {
    return {
      slug: this.$route.params.slug
    };
  },

  methods: {
    onLoaded: function onLoaded() {
      this.$emit('loaded');
    },
    onReload: function onReload() {
      this.$emit('reload');
    },
    onReloaded: function onReloaded() {
      this.$emit('reloaded');
    },
    onClass: function onClass(css_class) {
      this.$emit("cssclass", css_class);
    },
    initPage: function initPage() {
      var pageView = this.$refs.pageView;

      this.slug = this.$route.params.slug;
      pageView.initPage(this.slug);
    }
  },

  created: function created() {}
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_front_HeaderFront__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_front_HeaderFront___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_front_HeaderFront__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_front_AnimatedLoader__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_front_AnimatedLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_front_AnimatedLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_velocity_animate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_velocity_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_velocity_animate__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'front',
  firebase: {
    pages: __WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].db.ref('pages')
  },
  components: {
    HeaderFront: __WEBPACK_IMPORTED_MODULE_1__components_front_HeaderFront___default.a, AnimatedLoader: __WEBPACK_IMPORTED_MODULE_2__components_front_AnimatedLoader___default.a
  },
  data: function data() {
    return {
      title: __WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].PROJECT_NAME,
      isUser: false,
      isLoading: false,
      firstLoad: true,
      css_class: ''
    };
  },

  methods: {
    onClass: function onClass(css_class) {
      this.css_class = css_class;
    },

    beforeEnter: function beforeEnter(el) {},
    enter: function enter(el, done) {
      done();
    },
    afterEnter: function afterEnter(el) {},
    enterCancelled: function enterCancelled(el) {},
    showContent: function showContent() {
      this.$refs.aload.hide();

      __WEBPACK_IMPORTED_MODULE_4_velocity_animate___default()($("#content"), "scroll", { offset: 0, duration: 0 });

      __WEBPACK_IMPORTED_MODULE_4_velocity_animate___default()($("#content"), { opacity: 1 }, { duration: 800, transition: "easeInOutExpo" });
    },

    beforeLeave: function beforeLeave(el) {},

    leave: function leave(el, done) {
      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_4_velocity_animate___default()($("#content"), { opacity: 0 }, { duration: 300, transition: "easeInExpo", complete: done });
    },
    afterLeave: function afterLeave(el) {
      var aload = this.$refs.aload;

      if (this.isLoading) {
        aload.show();
        aload.startRandomGif();
      }
    },

    leaveCancelled: function leaveCancelled(el) {},

    onReload: function onReload() {
      var scope = this;
      var routerView = this.$refs.routerView;
      this.isLoading = true;
      var aload = this.$refs.aload;
      __WEBPACK_IMPORTED_MODULE_4_velocity_animate___default()($("#content"), { opacity: 0 }, { duration: 300, transition: "easeInExpo", complete: function complete() {
          scope.css_class = '';
          routerView.initPage();
          if (scope.isLoading) {
            aload.show();
            aload.startRandomGif();
          }
        } });
    },
    onLoaded: function onLoaded() {
      var aload = this.$refs.aload;
      var images = $("#content img");
      this.isLoading = false;
      aload.stopRandomGif();

      if (this.firstLoad) {
        this.firstLoad = false;
        aload.close();
      } else this.showContent();
    },
    onLoaderClose: function onLoaderClose() {
      var aload = this.$refs.aload;

      __WEBPACK_IMPORTED_MODULE_4_velocity_animate___default()($("#loader"), { opacity: 0 }, { duration: 800, transition: "easeInOutExpo",
        complete: function complete() {
          aload.hide();
          aload.unsetOverlay();

          __WEBPACK_IMPORTED_MODULE_4_velocity_animate___default()($("#loader"), { opacity: 1 }, { duration: 0 });
        }
      });
    }
  },

  created: function created() {

    $('body').css('overflow', 'hidden');
    var user = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().currentUser;
    this.isUser = user ? true : false;
    var scope = this;
  }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'header-front',
  firebase: {
    pages: __WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].db.ref('pages')
  },
  data: function data() {
    return {
      title: __WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].PROJECT_NAME,
      isUser: false,
      isNavOpen: false
    };
  },

  methods: {
    goToAdmin: function goToAdmin() {
      this.$router.push('/admin');
    },
    toggleNav: function toggleNav() {
      this.isNavOpen = !this.isNavOpen;
    }
  },

  created: function created() {
    var user = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser;
    this.isUser = user ? true : false;
  }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_front_HeaderFront__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_front_HeaderFront___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_front_HeaderFront__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_velocity_animate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_velocity_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_velocity_animate__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page-list',
  firebase: {
    pages: __WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].db.ref('pages').orderByChild('position')
  },
  components: {
    HeaderFront: __WEBPACK_IMPORTED_MODULE_2__components_front_HeaderFront___default.a
  },
  data: function data() {
    return {
      title: __WEBPACK_IMPORTED_MODULE_1__global__["a" /* default */].PROJECT_NAME,
      isUser: false
    };
  },

  methods: {
    goToAdmin: function goToAdmin() {
      this.$router.push('/admin');
    },
    loadAsset: function loadAsset(assets) {
      var scope = this;
      var imagesLoaded = 0;

      for (var i = 0; i < assets.length; i++) {
        var imageObj = new Image();
        imageObj.src = assets[i];
        console.log(i + " " + assets[i]);
        imageObj.onload = function () {
          imagesLoaded++;
          if (imagesLoaded == assets.length) scope.$emit('loaded');
        };
      }
    },
    smoothScrollTo: function smoothScrollTo(slug) {
      $("#" + slug).velocity('scroll', {
        duration: 1200,
        easing: 'easeInOutSine'
      });
    }
  },

  created: function created() {
    var scope = this;
    var user = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().currentUser;
    this.isUser = user ? true : false;

    scope.$emit("cssclass", 'work');

    this.$firebaseRefs.pages.once('value', function (pageSnapshot) {
      var headers = [];
      pageSnapshot.forEach(function (snapshot) {
        var object = snapshot.val();
        var slices = object.slices;
        var position = object.position;
        var published = object.published;

        var headerDOM = slices[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(slices)[0]].content;

        var src = headerDOM.match(/src="(.*?)"/);
        if (src && published) headers.push(src[1]);
      });
      scope.loadAsset(headers);
    });
  }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_front_HeaderFront__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_front_HeaderFront___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_front_HeaderFront__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scrollmagic__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scrollmagic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_scrollmagic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_split_text__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_split_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_split_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_velocity_animate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_velocity_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_velocity_animate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_croppie__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_croppie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_croppie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_imports_loader_define_false_scrollmagic_scrollmagic_uncompressed_plugins_animation_gsap_js__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_imports_loader_define_false_scrollmagic_scrollmagic_uncompressed_plugins_animation_gsap_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_imports_loader_define_false_scrollmagic_scrollmagic_uncompressed_plugins_animation_gsap_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_imports_loader_define_false_scrollmagic_scrollmagic_uncompressed_plugins_debug_addIndicators_js__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_imports_loader_define_false_scrollmagic_scrollmagic_uncompressed_plugins_debug_addIndicators_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_imports_loader_define_false_scrollmagic_scrollmagic_uncompressed_plugins_debug_addIndicators_js__);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page-edit',
  props: ['slug'],
  firebase: {
    pages: __WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].db.ref('pages')
  },

  components: {
    HeaderFront: __WEBPACK_IMPORTED_MODULE_1__components_front_HeaderFront___default.a
  },
  computed: {
    slicesToDisplay: {
      cache: false,
      get: function get() {
        return this.slices;
      }
    }
  },
  data: function data() {
    return {
      title: __WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].PROJECT_NAME,
      page: {},
      key: '',
      totalItems: 0,
      currentIndex: 0,
      slices: [],
      isUser: false,
      firstLoad: true,
      isReload: false,
      scrollController: null,
      prevPage: null,
      nextPage: null,
      listedPages: [],
      itvSlide: null,
      countSlide: 0,
      scrollTweens: []
    };
  },

  methods: {
    editPage: function editPage(page) {
      this.$router.push('/admin/edit/' + this.key);
    },
    loadAsset: function loadAsset(assets) {
      var scope = this;
      var imagesLoaded = 0;

      if (assets.length == 0) {
        scope.initScrollAnimation();
        return;
      }

      for (var i = 0; i < assets.length; i++) {
        var imageObj = new Image();
        imageObj.src = assets[i];
        imageObj.onload = function () {
          imagesLoaded++;
          if (imagesLoaded == assets.length) {
            scope.initScrollAnimation();
          }
        };
      }
    },
    refreshSliceView: function refreshSliceView() {
      var scope = this;
      var imgToLoad = [];

      this.slices = [];

      __WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */].db.ref('pages/' + this.key + '/slices').orderByChild('index').once('value', function (slicesSnapshot) {
        slicesSnapshot.forEach(function (snapshot) {
          var sliceKey = snapshot.key;
          var object = snapshot.val();

          if (scope.firstLoad) {
            var sliceDOM = object.content;

            var src = sliceDOM.match(/img.*?src="(.*?)"/);
            if (src) imgToLoad.push(src[1]);
          }

          object.sliceKey = sliceKey;
          scope.slices.push(object);
        });
        if (scope.firstLoad) {
          scope.firstLoad = false;
          scope.loadAsset(imgToLoad);
        }
      });
    },
    initPage: function initPage() {
      var nextSlug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.firstLoad = true;
      var scope = this;
      this.slices = [];
      var i = 0;

      var nextSlug = nextSlug ? nextSlug : this.slug;

      this.$firebaseRefs.pages.on('value', function (pagesSnapshot) {
        scope.totalItems = pagesSnapshot.numChildren();
        pagesSnapshot.forEach(function (snapshot) {
          var p = snapshot.val();

          if (p.slug == nextSlug) {
            scope.page = p;
            scope.currentIndex = i;
            scope.key = snapshot.key;
          }

          if (p.listed && p.published) {
            scope.listedPages.push(p);
            i++;
          }
        });
        scope.refreshSliceView();
        scope.getNextPrev();
      });

      var user = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().currentUser;
      this.isUser = user ? true : false;
    },
    getNextPrev: function getNextPrev() {

      var scope = this;
      var currentIndex = this.currentIndex;
      var totalIndex = this.listedPages.length - 1;

      var prevIndex = currentIndex - 1;
      if (prevIndex < 0) prevIndex = totalIndex;

      var nextIndex = currentIndex + 1;
      if (nextIndex > totalIndex) nextIndex = 0;

      this.prevPage = this.listedPages[prevIndex];
      this.nextPage = this.listedPages[nextIndex];
    },
    initScrollAnimation: function initScrollAnimation() {
      this.destroyScrollMagic();

      for (var i = this.scrollTweens.length - 1; i >= 0; i--) {
        this.scrollTweens[i].pause(0);
        this.scrollTweens[i].clear();
      };
      this.scrollTweens = [];

      this.scrollController = new __WEBPACK_IMPORTED_MODULE_4_scrollmagic___default.a.Controller();
      var start = this.page.listed ? 4 : 3;

      for (var i = start; i < this.slices.length; i++) {
        var slice = this.slices[i];
        var domId = "#slice_" + this.page.slug + "_" + i;

        $(domId).attr('style', '');
        TweenLite.set(domId, { clearProps: "all" });

        var isTween = false;
        var isReverse = false;

        if (slice.css_class.indexOf("quote") >= 0) {
          var tween = new __WEBPACK_IMPORTED_MODULE_3_gsap__["TimelineMax"]().to(domId, 1.5, { opacity: 1, scale: 1, ease: Power3.easeOut });
          TweenLite.set(domId, { opacity: 0, scale: 1.3 });

          isTween = true;
        } else if (slice.css_class.indexOf("img-float-left") >= 0 || slice.css_class.indexOf("off") >= 0) {
          if (slice.css_class.indexOf("slide") >= 0) {
            var tween = new __WEBPACK_IMPORTED_MODULE_3_gsap__["TimelineMax"]().to(domId, 1.8, { opacity: 1, left: 0, ease: Sine.easeOut });
            TweenLite.set(domId, { opacity: 0, left: "50%" });
          } else if (slice.css_class.indexOf("reveal") >= 0) {
            var tween = new __WEBPACK_IMPORTED_MODULE_3_gsap__["TimelineMax"]().to(domId, 1.8, { left: 0, ease: Expo.easeOut });
            TweenLite.set(domId, { left: "-50%" });
          } else {
            var tween = new __WEBPACK_IMPORTED_MODULE_3_gsap__["TimelineMax"]().to(domId, 1, { opacity: 1, left: 0, ease: Sine.easeOut, rotation: 0 });
            TweenLite.set(domId, { opacity: 0, left: "-100px", rotation: 20, transformOrigin: "left center" });
          }
          isTween = isReverse = true;
        } else if (slice.css_class.indexOf("img-float-right") >= 0) {
          if (slice.css_class.indexOf("slide") >= 0) {
            var tween = new __WEBPACK_IMPORTED_MODULE_3_gsap__["TimelineMax"]().to(domId, 1.8, { opacity: 1, right: 0, ease: Sine.easeOut });
            TweenLite.set(domId, { opacity: 0, right: "50%" });
          } else if (slice.css_class.indexOf("reveal") >= 0) {
            var tween = new __WEBPACK_IMPORTED_MODULE_3_gsap__["TimelineMax"]().to(domId, 1.8, { right: 0, ease: Expo.easeOut });
            TweenLite.set(domId, { right: "-50%" });
          } else {
            var tween = new __WEBPACK_IMPORTED_MODULE_3_gsap__["TimelineMax"]().to(domId, 1, { opacity: 1, right: 0, ease: Sine.easeOut, rotation: 0 });
            TweenLite.set(domId, { opacity: 0, right: "-100px", rotation: 20, transformOrigin: "right center" });
          }
          isTween = isReverse = true;
        } else {
            var tween = new __WEBPACK_IMPORTED_MODULE_3_gsap__["TimelineMax"]().to(domId, .8, { opacity: 1 });
            TweenLite.set(domId, { opacity: 0 });
            isTween = true;
          }

        if (isTween) this.scrollTweens.push(tween);
        new __WEBPACK_IMPORTED_MODULE_4_scrollmagic___default.a.Scene({
          triggerElement: domId,
          reverse: false
        }).setTween(tween).addTo(this.scrollController);
      };

      this.scrollController.update(true);
      this.emitEnd();
    },
    emitEnd: function emitEnd() {
      var scope = this;

      this.$emit('loaded');

      if (this.page.css_class) this.$emit("cssclass", this.page.css_class);else this.$emit("cssclass", '');

      if (this.page.css_class == 'contact') {
        this.resizeContact();
        $(window).resize(function () {
          scope.resizeContact();
        });
      }
    },
    resizeContact: function resizeContact() {
      var ratio = $(window).height() / 1024;
      var next_w = Math.round(ratio * 685);
      var r = 80 + next_w;
      $("#slice_contact_2").css('right', r + 'px');
      $("#slice_contact_1").css('right', r - 350 + 'px');
    },
    destroyScrollMagic: function destroyScrollMagic() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      if (this.scrollController) {
        this.scrollController.destroy(true);
        this.scrollController = null;
      }
    }
  },

  created: function created() {
    this.initPage();
    var w = Math.round($(window).width() * 0.75 * 0.5);
  },
  destroyed: function destroyed() {
    clearInterval(this.itvSlide);
  },
  watch: {
    '$route': function $route(to, from) {
      this.isReload = true;
      this.$emit('reload');
    }
  }

});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuefire__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_html5_editor__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_html5_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_html5_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sortablejs__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sortablejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sortablejs__);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('sortable', {
    inserted: function inserted(el, binding) {
        new __WEBPACK_IMPORTED_MODULE_6_sortablejs___default.a(el, binding.value || {});
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('tooltip', function (el, binding) {
    $(el).tooltip({
        title: binding.value,
        placement: binding.arg,
        trigger: 'hover',
        container: 'body'
    });
    $(el).on('click', function () {
        $(this).tooltip('hide');
    });
});

var editorOptions = {
    name: "vue-html5-editor",

    showModuleName: false,

    icons: {
        text: "fa fa-pencil",
        color: "fa fa-paint-brush",
        font: "fa fa-font",
        align: "fa fa-align-justify",
        list: "fa fa-list",
        link: "fa fa-chain",
        unlink: "fa fa-chain-broken",
        tabulation: "fa fa-table",
        image: "fa fa-file-image-o",
        hr: "fa fa-minus",
        eraser: "fa fa-eraser",
        undo: "fa-undo fa",
        "full-screen": "fa fa-arrows-alt",
        info: "fa fa-info"
    },

    image: {
        sizeLimit: 512 * 1024,

        upload: {
            url: null,
            headers: {},
            params: {},
            fieldName: {}
        },

        compress: {
            width: 1600,
            height: 1600,
            quality: 80
        },
        uploadHandler: function uploadHandler(responseText) {
            var json = JSON.parse(responseText);
            if (!json.ok) {
                alert(json.msg);
            } else {
                return json.data;
            }
        }
    },

    hiddenModules: ["font-name"],

    visibleModules: ["text", "align", "list", "link", "unlink", "image", "eraser", "undo"],

    modules: {}
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_html5_editor___default.a, editorOptions);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuefire___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('timestampToDate', function (value) {
    return __WEBPACK_IMPORTED_MODULE_4_moment___default()(value, "x").format("DD/MM/YYYY - HH:mm");
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a },

    mounted: function mounted() {
        $('[data-toggle="tooltip"]').tooltip();
    }
});

/***/ }),
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 22,
	"./af.js": 22,
	"./ar": 29,
	"./ar-dz": 23,
	"./ar-dz.js": 23,
	"./ar-kw": 24,
	"./ar-kw.js": 24,
	"./ar-ly": 25,
	"./ar-ly.js": 25,
	"./ar-ma": 26,
	"./ar-ma.js": 26,
	"./ar-sa": 27,
	"./ar-sa.js": 27,
	"./ar-tn": 28,
	"./ar-tn.js": 28,
	"./ar.js": 29,
	"./az": 30,
	"./az.js": 30,
	"./be": 31,
	"./be.js": 31,
	"./bg": 32,
	"./bg.js": 32,
	"./bm": 33,
	"./bm.js": 33,
	"./bn": 34,
	"./bn.js": 34,
	"./bo": 35,
	"./bo.js": 35,
	"./br": 36,
	"./br.js": 36,
	"./bs": 37,
	"./bs.js": 37,
	"./ca": 38,
	"./ca.js": 38,
	"./cs": 39,
	"./cs.js": 39,
	"./cv": 40,
	"./cv.js": 40,
	"./cy": 41,
	"./cy.js": 41,
	"./da": 42,
	"./da.js": 42,
	"./de": 45,
	"./de-at": 43,
	"./de-at.js": 43,
	"./de-ch": 44,
	"./de-ch.js": 44,
	"./de.js": 45,
	"./dv": 46,
	"./dv.js": 46,
	"./el": 47,
	"./el.js": 47,
	"./en-au": 48,
	"./en-au.js": 48,
	"./en-ca": 49,
	"./en-ca.js": 49,
	"./en-gb": 50,
	"./en-gb.js": 50,
	"./en-ie": 51,
	"./en-ie.js": 51,
	"./en-nz": 52,
	"./en-nz.js": 52,
	"./eo": 53,
	"./eo.js": 53,
	"./es": 56,
	"./es-do": 54,
	"./es-do.js": 54,
	"./es-us": 55,
	"./es-us.js": 55,
	"./es.js": 56,
	"./et": 57,
	"./et.js": 57,
	"./eu": 58,
	"./eu.js": 58,
	"./fa": 59,
	"./fa.js": 59,
	"./fi": 60,
	"./fi.js": 60,
	"./fo": 61,
	"./fo.js": 61,
	"./fr": 64,
	"./fr-ca": 62,
	"./fr-ca.js": 62,
	"./fr-ch": 63,
	"./fr-ch.js": 63,
	"./fr.js": 64,
	"./fy": 65,
	"./fy.js": 65,
	"./gd": 66,
	"./gd.js": 66,
	"./gl": 67,
	"./gl.js": 67,
	"./gom-latn": 68,
	"./gom-latn.js": 68,
	"./gu": 69,
	"./gu.js": 69,
	"./he": 70,
	"./he.js": 70,
	"./hi": 71,
	"./hi.js": 71,
	"./hr": 72,
	"./hr.js": 72,
	"./hu": 73,
	"./hu.js": 73,
	"./hy-am": 74,
	"./hy-am.js": 74,
	"./id": 75,
	"./id.js": 75,
	"./is": 76,
	"./is.js": 76,
	"./it": 77,
	"./it.js": 77,
	"./ja": 78,
	"./ja.js": 78,
	"./jv": 79,
	"./jv.js": 79,
	"./ka": 80,
	"./ka.js": 80,
	"./kk": 81,
	"./kk.js": 81,
	"./km": 82,
	"./km.js": 82,
	"./kn": 83,
	"./kn.js": 83,
	"./ko": 84,
	"./ko.js": 84,
	"./ky": 85,
	"./ky.js": 85,
	"./lb": 86,
	"./lb.js": 86,
	"./lo": 87,
	"./lo.js": 87,
	"./lt": 88,
	"./lt.js": 88,
	"./lv": 89,
	"./lv.js": 89,
	"./me": 90,
	"./me.js": 90,
	"./mi": 91,
	"./mi.js": 91,
	"./mk": 92,
	"./mk.js": 92,
	"./ml": 93,
	"./ml.js": 93,
	"./mr": 94,
	"./mr.js": 94,
	"./ms": 96,
	"./ms-my": 95,
	"./ms-my.js": 95,
	"./ms.js": 96,
	"./my": 97,
	"./my.js": 97,
	"./nb": 98,
	"./nb.js": 98,
	"./ne": 99,
	"./ne.js": 99,
	"./nl": 101,
	"./nl-be": 100,
	"./nl-be.js": 100,
	"./nl.js": 101,
	"./nn": 102,
	"./nn.js": 102,
	"./pa-in": 103,
	"./pa-in.js": 103,
	"./pl": 104,
	"./pl.js": 104,
	"./pt": 106,
	"./pt-br": 105,
	"./pt-br.js": 105,
	"./pt.js": 106,
	"./ro": 107,
	"./ro.js": 107,
	"./ru": 108,
	"./ru.js": 108,
	"./sd": 109,
	"./sd.js": 109,
	"./se": 110,
	"./se.js": 110,
	"./si": 111,
	"./si.js": 111,
	"./sk": 112,
	"./sk.js": 112,
	"./sl": 113,
	"./sl.js": 113,
	"./sq": 114,
	"./sq.js": 114,
	"./sr": 116,
	"./sr-cyrl": 115,
	"./sr-cyrl.js": 115,
	"./sr.js": 116,
	"./ss": 117,
	"./ss.js": 117,
	"./sv": 118,
	"./sv.js": 118,
	"./sw": 119,
	"./sw.js": 119,
	"./ta": 120,
	"./ta.js": 120,
	"./te": 121,
	"./te.js": 121,
	"./tet": 122,
	"./tet.js": 122,
	"./th": 123,
	"./th.js": 123,
	"./tl-ph": 124,
	"./tl-ph.js": 124,
	"./tlh": 125,
	"./tlh.js": 125,
	"./tr": 126,
	"./tr.js": 126,
	"./tzl": 127,
	"./tzl.js": 127,
	"./tzm": 129,
	"./tzm-latn": 128,
	"./tzm-latn.js": 128,
	"./tzm.js": 129,
	"./uk": 130,
	"./uk.js": 130,
	"./ur": 131,
	"./ur.js": 131,
	"./uz": 133,
	"./uz-latn": 132,
	"./uz-latn.js": 132,
	"./uz.js": 133,
	"./vi": 134,
	"./vi.js": 134,
	"./x-pseudo": 135,
	"./x-pseudo.js": 135,
	"./yo": 136,
	"./yo.js": 136,
	"./zh-cn": 137,
	"./zh-cn.js": 137,
	"./zh-hk": 138,
	"./zh-hk.js": 138,
	"./zh-tw": 139,
	"./zh-tw.js": 139
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 234;

/***/ }),
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loader.d1356d7.png";

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(226)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(151),
  /* template */
  __webpack_require__(273),
  /* scopeId */
  "data-v-fcb8c3c4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(213)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(264),
  /* scopeId */
  "data-v-7ecb2da3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(218)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(153),
  /* template */
  __webpack_require__(267),
  /* scopeId */
  "data-v-9a7f57f6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(220)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(154),
  /* template */
  __webpack_require__(269),
  /* scopeId */
  "data-v-af47d9ea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(221)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(270),
  /* scopeId */
  "data-v-b4ee705c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(197)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(156),
  /* template */
  __webpack_require__(254),
  /* scopeId */
  "data-v-01b554c8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(204)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(157),
  /* template */
  __webpack_require__(259),
  /* scopeId */
  "data-v-2967acca",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(217)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(266),
  /* scopeId */
  "data-v-9524fdc4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(203)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(159),
  /* template */
  __webpack_require__(258),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(222)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(160),
  /* template */
  __webpack_require__(271),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(219)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(268),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(223)
__webpack_require__(224)
__webpack_require__(225)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(272),
  /* scopeId */
  "data-v-ea0c9228",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(214)
__webpack_require__(215)
__webpack_require__(216)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(163),
  /* template */
  __webpack_require__(265),
  /* scopeId */
  "data-v-8f5dd7f0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(199)
__webpack_require__(200)
__webpack_require__(201)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(256),
  /* scopeId */
  "data-v-1b4086c3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(205)
__webpack_require__(206)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(260),
  /* scopeId */
  "data-v-48a75bba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-edit container"
  }, [_c('div', {
    staticClass: "row container"
  }, [_c('header-back')], 1), _vm._v(" "), _c('div', {
    staticClass: "col col-md-5"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('strong', [_vm._v("Edit Page #" + _vm._s(_vm.key))])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    staticClass: "form",
    attrs: {
      "id": "form-create"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validate($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "pageTitle"
    }
  }, [_vm._v("Title:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "pageTitle"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('slug-field', {
    attrs: {
      "string-to-slug": _vm.stringToSlug
    },
    on: {
      "update": _vm.updatePageSlug
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "pageCSSClass"
    }
  }, [_vm._v("CSS Class")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPage.css_class),
      expression: "currentPage.css_class"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "pageCSSClass"
    },
    domProps: {
      "value": (_vm.currentPage.css_class)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentPage, "css_class", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPage.listed),
      expression: "currentPage.listed"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "pagePosition"
    }
  }, [_vm._v("Position")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPage.position),
      expression: "currentPage.position"
    }],
    attrs: {
      "type": "text",
      "id": "pagePosition"
    },
    domProps: {
      "value": (_vm.currentPage.position)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentPage, "position", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPage.published),
      expression: "currentPage.published"
    }],
    attrs: {
      "type": "checkbox",
      "id": "pagePublished"
    },
    domProps: {
      "checked": Array.isArray(_vm.currentPage.published) ? _vm._i(_vm.currentPage.published, null) > -1 : (_vm.currentPage.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.currentPage.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.currentPage.published = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.currentPage.published = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.currentPage, "published", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "pagePublished"
    }
  }, [_vm._v("Published")]), _vm._v(" | \n\t\t\t\t\t\t"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPage.locked),
      expression: "currentPage.locked"
    }],
    attrs: {
      "type": "checkbox",
      "id": "pageLocked"
    },
    domProps: {
      "checked": Array.isArray(_vm.currentPage.locked) ? _vm._i(_vm.currentPage.locked, null) > -1 : (_vm.currentPage.locked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.currentPage.locked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.currentPage.locked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.currentPage.locked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.currentPage, "locked", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "pageLocked"
    }
  }, [_vm._v("Locked")]), _vm._v(" | \n\t\t\t\t\t\t"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPage.listed),
      expression: "currentPage.listed"
    }],
    attrs: {
      "type": "checkbox",
      "id": "pageListed"
    },
    domProps: {
      "checked": Array.isArray(_vm.currentPage.listed) ? _vm._i(_vm.currentPage.listed, null) > -1 : (_vm.currentPage.listed)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.currentPage.listed,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.currentPage.listed = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.currentPage.listed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.currentPage, "listed", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "pageListed"
    }
  }, [_vm._v("Listed")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group dates"
  }, [_c('p', [_c('strong', [_vm._v("Created:")]), _vm._v(" " + _vm._s(_vm._f("timestampToDate")(_vm.currentPage.created))), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Last update:")]), _vm._v("  " + _vm._s(_vm._f("timestampToDate")(_vm.currentPage.updated)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "value": "/ Edit"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-info",
    attrs: {
      "to": {
        path: '/work/' + _vm.currentPage.slug
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Preview")])], 1)], 1)])]), _vm._v(" "), _c('file-manager', {
    attrs: {
      "page-key": _vm.key
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col col-md-7"
  }, [_c('slice-manager', {
    attrs: {
      "page-key": _vm.key
    },
    on: {
      "update": _vm.updatePageData
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "slugField"
    }
  }, [_vm._v("Slug:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.slug),
      expression: "slug"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "slugField"
    },
    domProps: {
      "value": (_vm.slug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.slug = $event.target.value
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.css_class,
    attrs: {
      "id": "front"
    }
  }, [_c('header-front'), _vm._v(" "), _c('animated-loader', {
    ref: "aload",
    attrs: {
      "id": "loader"
    },
    on: {
      "close": _vm.onLoaderClose
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('transition', {
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "after-enter": _vm.afterEnter,
      "enter-cancelled": _vm.enterCancelled,
      "before-leave": _vm.beforeLeave,
      "leave": _vm.leave,
      "after-leave": _vm.afterLeave,
      "leave-cancelled": _vm.leaveCancelled
    }
  }, [_c('router-view', {
    ref: "routerView",
    on: {
      "reload": _vm.onReload,
      "loaded": _vm.onLoaded,
      "cssclass": _vm.onClass
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "bg"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": '/admin'
    }
  }, [_vm._v("\n\t\t    " + _vm._s(_vm.title) + "\n\t\t  ")])], 1), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v(_vm._s(_vm.email)), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": '/'
    }
  }, [_vm._v("Home Front")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/admin'
    }
  }, [_vm._v("Home Admin")])], 1), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v("Sign out")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.modalTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "sliceImgUrl"
    }
  }, [_vm._v("Image URL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imgUrl),
      expression: "imgUrl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "sliceImgUrl"
    },
    domProps: {
      "value": (_vm.imgUrl)
    },
    on: {
      "change": _vm.onChangeImgUrl,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.imgUrl = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "sliceImgPosition"
    }
  }, [_vm._v("Position")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "id": "sliceImgPosition",
      "options": [{
        label: 'Left',
        value: 'img-float-left'
      }, {
        label: 'Center',
        value: 'asset'
      }, {
        label: 'Right',
        value: 'img-float-right'
      }, {
        label: 'Header',
        value: 'header'
      }, {
        label: 'Header Wide',
        value: 'header header-wide'
      }]
    },
    model: {
      value: (_vm.position),
      callback: function($$v) {
        _vm.position = $$v
      },
      expression: "position"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "sliceImgAnimation"
    }
  }, [_vm._v("Animation")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "id": "sliceImgAnimation",
      "options": [{
        label: 'Rotation',
        value: 'rotation'
      }, {
        label: 'Slide',
        value: 'slide'
      }, {
        label: 'Reveal',
        value: 'reveal'
      }]
    },
    model: {
      value: (_vm.animation),
      callback: function($$v) {
        _vm.animation = $$v
      },
      expression: "animation"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSlice.visible),
      expression: "currentSlice.visible"
    }],
    attrs: {
      "type": "checkbox",
      "id": "sliceImgVisible"
    },
    domProps: {
      "checked": Array.isArray(_vm.currentSlice.visible) ? _vm._i(_vm.currentSlice.visible, null) > -1 : (_vm.currentSlice.visible)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.currentSlice.visible,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.currentSlice.visible = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.currentSlice.visible = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.currentSlice, "visible", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "sliceImgVisible"
    }
  }, [_vm._v("Visible")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSlice.locked),
      expression: "currentSlice.locked"
    }],
    attrs: {
      "type": "checkbox",
      "id": "sliceImgLocked"
    },
    domProps: {
      "checked": Array.isArray(_vm.currentSlice.locked) ? _vm._i(_vm.currentSlice.locked, null) > -1 : (_vm.currentSlice.locked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.currentSlice.locked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.currentSlice.locked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.currentSlice.locked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.currentSlice, "locked", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "sliceImgLocked"
    }
  }, [_vm._v("Locked")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveSlice
    }
  }, [_vm._v("Save")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}

/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#sliceModal"
    },
    on: {
      "click": _vm.resetSlice
    }
  }, [_vm._v("+ Add Slice")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#sliceImgModal"
    },
    on: {
      "click": _vm.resetSlice
    }
  }, [_vm._v("+ Add Image Slice")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#sliceQuoteModal"
    },
    on: {
      "click": _vm.resetSlice
    }
  }, [_vm._v("+ Add Quote Slice")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#sliceCreditsModal"
    },
    on: {
      "click": _vm.resetSlice
    }
  }, [_vm._v("+ Add Credits Slice")]), _vm._v(" "), _c('modal-slice', {
    attrs: {
      "id": "sliceModal",
      "modal-title": _vm.modalTitle,
      "current-slice": _vm.currentSlice
    },
    on: {
      "save": _vm.saveSlice
    }
  }), _vm._v(" "), _c('modal-img-slice', {
    attrs: {
      "id": "sliceImgModal",
      "modal-title": _vm.modalTitle,
      "current-slice": _vm.currentSlice
    },
    on: {
      "save": _vm.saveSlice
    }
  }), _vm._v(" "), _c('modal-quote', {
    attrs: {
      "id": "sliceQuoteModal",
      "modal-title": _vm.modalTitle,
      "current-slice": _vm.currentSlice
    },
    on: {
      "save": _vm.saveSlice
    }
  }), _vm._v(" "), _c('modal-credits', {
    attrs: {
      "id": "sliceCreditsModal",
      "modal-title": _vm.modalTitle,
      "current-slice": _vm.currentSlice
    },
    on: {
      "save": _vm.saveSlice
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    directives: [{
      name: "sortable",
      rawName: "v-sortable",
      value: ({
        handle: '.handle',
        onUpdate: _vm.onDragSlice
      }),
      expression: "{ handle: '.handle', onUpdate: onDragSlice }"
    }],
    staticClass: "panel-group list-group",
    attrs: {
      "id": "slices"
    }
  }, _vm._l((_vm.slices), function(slice, sliceKey) {
    return _c('div', {
      staticClass: "panel panel-default list-group-item"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('h4', {
      staticClass: "panel-title"
    }, [_vm._m(1, true), _vm._v(" "), (slice.name == '' || !slice.name) ? _c('a', {
      attrs: {
        "data-toggle": "collapse",
        "data-parent": "#slices",
        "href": '#' + slice.sliceKey
      }
    }, [_vm._v("\n                    Slice #" + _vm._s(slice.sliceKey) + "\n                  ")]) : _c('a', {
      attrs: {
        "data-toggle": "collapse",
        "data-parent": "#slices",
        "href": '#' + slice.sliceKey
      }
    }, [_vm._v("\n                    " + _vm._s(slice.name) + "\n                  ")]), _vm._v(" "), _c('b', [_vm._v("Index: " + _vm._s(slice.index))]), _vm._v(" "), _c('a', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:top",
        value: ('Remove'),
        expression: "'Remove'",
        arg: "top"
      }],
      staticClass: "action",
      class: {
        disabled: slice.locked
      },
      on: {
        "click": function($event) {
          _vm.removeSlice(slice, slice.sliceKey)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('a', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:top",
        value: ('Edit'),
        expression: "'Edit'",
        arg: "top"
      }],
      staticClass: "action",
      on: {
        "click": function($event) {
          _vm.editSlice(slice, slice.sliceKey)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "panel-collapse collapse",
      attrs: {
        "id": slice.sliceKey
      }
    }, [_c('div', {
      staticClass: "panel-body"
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(slice.content)
      }
    })])])])
  }))], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('strong', [_vm._v("Slices")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "action handle"
  }, [_c('i', {
    staticClass: "fa fa-bars handle",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-list"
  }, [_c('ul', {
    staticClass: "nav page-content"
  }, _vm._l((_vm.pages), function(page) {
    return (page.listed && page.published) ? _c('li', {
      staticClass: "nav-item",
      attrs: {
        "id": page.slug
      }
    }, [_c('router-link', {
      staticClass: "thumb",
      attrs: {
        "to": '/work/' + page.slug
      }
    }, _vm._l((page.slices), function(slice) {
      return (slice.index < 3) ? _c('div', {
        class: slice.css_class
      }, [_c('div', {
        domProps: {
          "innerHTML": _vm._s(slice.content)
        }
      })]) : _vm._e()
    }))], 1) : _vm._e()
  })), _vm._v(" "), _c('div', {
    attrs: {
      "id": "anchor-nav"
    }
  }, [_c('ul', _vm._l((_vm.pages), function(page) {
    return (page.listed && page.published) ? _c('li', {
      staticClass: "anchor-nav-item"
    }, [_c('a', {
      attrs: {
        "href": '#' + page.slug
      },
      on: {
        "click": function($event) {
          _vm.smoothScrollTo(page.slug)
        }
      }
    }, [_vm._v("\n            " + _vm._s(page.title) + "\n        ")]), _vm._v(" "), _vm._m(0, true)]) : _vm._e()
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hr')])
}]}

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    class: {
      open: _vm.isNavOpen
    }
  }, [_vm._m(0), _vm._v(" "), _c('h1', {
    staticClass: "logo"
  }, [_c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": '/'
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "nav-icon"
    },
    on: {
      "click": _vm.toggleNav
    }
  }, [_c('span', {
    staticClass: "n1"
  }), _vm._v(" "), _c('span', {
    staticClass: "n2"
  }), _vm._v(" "), _c('span', {
    staticClass: "n3"
  })]), _vm._v(" "), _c('nav', [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": '/work'
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleNav($event)
      }
    }
  }, [_vm._v("Work")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/about'
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleNav($event)
      }
    }
  }, [_vm._v("About")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/contact'
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleNav($event)
      }
    }
  }, [_vm._v("Contact")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Choreographer\u2028 "), _c('span', {
    staticClass: "cardo"
  }, [_vm._v("&")]), _vm._v(" Dancer")])
}]}

/***/ }),
/* 262 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-view",
    class: _vm.page.css_class
  }, [_c('div', {
    staticClass: "page-content",
    attrs: {
      "id": "slices"
    }
  }, _vm._l((_vm.slicesToDisplay), function(slice, sliceKey) {
    return (slice.visible) ? _c('div', {
      style: (slice.css_style)
    }, [(slice.css_class == 'video') ? _c('div', {
      staticClass: "video-container",
      attrs: {
        "id": 'slice_' + _vm.page.slug + '_' + sliceKey
      }
    }, [_c('div', {
      class: 'slice ' + slice.css_class,
      domProps: {
        "innerHTML": _vm._s(slice.content)
      }
    })]) : _vm._e(), _vm._v(" "), (slice.css_class != 'video') ? _c('div', {
      class: 'slice ' + slice.css_class,
      attrs: {
        "id": 'slice_' + _vm.page.slug + '_' + sliceKey
      },
      domProps: {
        "innerHTML": _vm._s(slice.content)
      }
    }) : _vm._e()]) : _vm._e()
  })), _vm._v(" "), (_vm.page.listed) ? _c('div', {
    attrs: {
      "id": "nav-page"
    }
  }, [(_vm.page.listed) ? _c('div', {
    attrs: {
      "id": "prev-next"
    }
  }, [(_vm.prevPage) ? _c('router-link', {
    staticClass: "thumb prev",
    attrs: {
      "to": '/work/' + _vm.prevPage.slug
    }
  }, _vm._l((_vm.prevPage.slices), function(slice) {
    return (slice.index < 3) ? _c('div', {
      class: slice.css_class
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(slice.content)
      }
    })]) : _vm._e()
  })) : _vm._e(), _vm._v(" "), (_vm.nextPage) ? _c('router-link', {
    staticClass: "thumb next",
    attrs: {
      "to": '/work/' + _vm.nextPage.slug
    }
  }, _vm._l((_vm.nextPage.slices), function(slice) {
    return (slice.index < 3) ? _c('div', {
      class: slice.css_class
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(slice.content)
      }
    })]) : _vm._e()
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.page.slug == 'home') ? _c('router-link', {
    attrs: {
      "id": "push-home",
      "to": '/work'
    }
  }, [_c('p', [_vm._v("Discover the pieces")])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    staticClass: "form",
    attrs: {
      "id": "form-create"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validate($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "pageTitle"
    }
  }, [_vm._v("Title:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "pageTitle"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('slug-field', {
    attrs: {
      "string-to-slug": _vm.stringToSlug
    },
    on: {
      "update": _vm.updatePageSlug
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary",
    class: {
      disabled: !_vm.active
    },
    attrs: {
      "type": "submit",
      "value": "+ Create"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('strong', [_vm._v("New Page")])])
}]}

/***/ }),
/* 265 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-view', {
    ref: "pageView",
    attrs: {
      "slug": _vm.slug
    },
    on: {
      "reload": _vm.onReload,
      "reloaded": _vm.onReloaded,
      "loaded": _vm.onLoaded,
      "cssclass": _vm.onClass
    }
  })
},staticRenderFns: []}

/***/ }),
/* 266 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.modalTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "sliceCreditSubtitle"
    }
  }, [_vm._v("Subtitle")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subtitle),
      expression: "subtitle"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "sliceCreditSubtitle"
    },
    domProps: {
      "value": (_vm.subtitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subtitle = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentRole),
      expression: "currentRole"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Role",
      "id": "sliceCreditsRole"
    },
    domProps: {
      "value": (_vm.currentRole)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentRole = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentName),
      expression: "currentName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name",
      "id": "sliceCreditsName"
    },
    domProps: {
      "value": (_vm.currentName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addCredit
    }
  }, [_vm._v("Add credit")])])])]), _vm._v(" "), _c('div', {
    staticClass: "credits",
    attrs: {
      "id": "creditsHolder"
    }
  }, [_c('ul', _vm._l((_vm.credits), function(credit) {
    return _c('li', [_c('b', [_vm._v(_vm._s(credit.role))]), (credit.name && credit.role) ? _c('span', [_vm._v(" ")]) : _vm._e(), _vm._v(_vm._s(credit.name) + "\n                "), _c('button', {
      staticClass: "btn",
      attrs: {
        "type": "button",
        "id": "removeCreditBtn"
      },
      on: {
        "click": function($event) {
          _vm.removeCredit(credit)
        }
      }
    }, [_vm._v("X")])])
  }))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSlice.visible),
      expression: "currentSlice.visible"
    }],
    attrs: {
      "type": "checkbox",
      "id": "sliceCreditsVisible"
    },
    domProps: {
      "checked": Array.isArray(_vm.currentSlice.visible) ? _vm._i(_vm.currentSlice.visible, null) > -1 : (_vm.currentSlice.visible)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.currentSlice.visible,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.currentSlice.visible = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.currentSlice.visible = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.currentSlice, "visible", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "sliceCreditsVisible"
    }
  }, [_vm._v("Visible")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSlice.locked),
      expression: "currentSlice.locked"
    }],
    attrs: {
      "type": "checkbox",
      "id": "sliceCreditsLocked"
    },
    domProps: {
      "checked": Array.isArray(_vm.currentSlice.locked) ? _vm._i(_vm.currentSlice.locked, null) > -1 : (_vm.currentSlice.locked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.currentSlice.locked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.currentSlice.locked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.currentSlice.locked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.currentSlice, "locked", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "sliceCreditsLocked"
    }
  }, [_vm._v("Locked")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveSlice
    }
  }, [_vm._v("Save")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}

/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.pages), function(page) {
    return _c('tr', [_c('td', [_c('router-link', {
      attrs: {
        "to": 'work/' + page.slug
      }
    }, [_vm._v(_vm._s(page.title))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(page.slug))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(page.position))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm._f("timestampToDate")(page.updated)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(page.published))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:top",
        value: ('Clone'),
        expression: "'Clone'",
        arg: "top"
      }],
      staticClass: "action",
      on: {
        "click": function($event) {
          _vm.clonePage(page)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-clone",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('td', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:top",
        value: ('Edit'),
        expression: "'Edit'",
        arg: "top"
      }],
      staticClass: "action",
      on: {
        "click": function($event) {
          _vm.editPage(page)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('td', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:top",
        value: ('Remove'),
        expression: "'Remove'",
        arg: "top"
      }],
      staticClass: "action",
      class: {
        disabled: page.locked
      },
      on: {
        "click": function($event) {
          _vm.removePage(page)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('strong', [_vm._v("Pages")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Slug")]), _vm._v(" "), _c('th', [_vm._v("Position")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Updated")]), _vm._v(" "), _c('th', [_vm._v("Published")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
}]}

/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.modalTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "sliceName"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSlice.name),
      expression: "currentSlice.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "sliceName"
    },
    domProps: {
      "value": (_vm.currentSlice.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentSlice, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": "html-editor"
    }
  }, [_c('vue-html5-editor', {
    attrs: {
      "content": _vm.currentSlice.content,
      "height": 200,
      "z-index": 1000,
      "auto-height": true,
      "show-module-name": false
    },
    on: {
      "change": _vm.onChangeContent
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "html-source"
    }
  }, [_c('label', [_vm._v("HTML code only :")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSlice.content),
      expression: "currentSlice.content"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "10"
    },
    domProps: {
      "value": (_vm.currentSlice.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentSlice, "content", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "sliceCSSClass"
    }
  }, [_vm._v("CSS Class")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSlice.css_class),
      expression: "currentSlice.css_class"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "sliceCSSClass"
    },
    domProps: {
      "value": (_vm.currentSlice.css_class)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentSlice, "css_class", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "sliceCSSStyle"
    }
  }, [_vm._v("CSS Style")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSlice.css_style),
      expression: "currentSlice.css_style"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "sliceCSSStyle"
    },
    domProps: {
      "value": (_vm.currentSlice.css_style)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentSlice, "css_style", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSlice.visible),
      expression: "currentSlice.visible"
    }],
    attrs: {
      "type": "checkbox",
      "id": "sliceVisible"
    },
    domProps: {
      "checked": Array.isArray(_vm.currentSlice.visible) ? _vm._i(_vm.currentSlice.visible, null) > -1 : (_vm.currentSlice.visible)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.currentSlice.visible,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.currentSlice.visible = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.currentSlice.visible = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.currentSlice, "visible", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "sliceVisible"
    }
  }, [_vm._v("Visible")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSlice.locked),
      expression: "currentSlice.locked"
    }],
    attrs: {
      "type": "checkbox",
      "id": "sliceLocked"
    },
    domProps: {
      "checked": Array.isArray(_vm.currentSlice.locked) ? _vm._i(_vm.currentSlice.locked, null) > -1 : (_vm.currentSlice.locked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.currentSlice.locked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.currentSlice.locked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.currentSlice.locked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.currentSlice, "locked", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "sliceLocked"
    }
  }, [_vm._v("Locked")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveSlice
    }
  }, [_vm._v("Save")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#html-editor"
    }
  }, [_vm._v("HTML: editor")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#html-source"
    }
  }, [_vm._v("HTML: source")])])])
}]}

/***/ }),
/* 269 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default "
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    staticClass: "form",
    attrs: {
      "id": "form-login"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "login"
    }
  }, [_vm._v("Email:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "pwd"
    }
  }, [_vm._v("Password:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "pwd"
    },
    domProps: {
      "value": (_vm.pwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pwd = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "sub",
      "type": "submit",
      "value": "> Login"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.error !== '') ? _c('div', {
    staticClass: "alert alert-danger alert-dismissible"
  }, [_vm._v("\n\t\t\t  " + _vm._s(_vm.error) + "\n\t\t\t")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('strong', [_vm._v("Login")])])
}]}

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-manager"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    staticClass: "form",
    attrs: {
      "id": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addFile($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "fileBrowser"
    },
    on: {
      "change": _vm.onFileChange
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "value": "+ Add"
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.files), function(file) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "target": "_blank",
        "href": file.url
      }
    }, [_vm._v(_vm._s(file.name))])]), _vm._v(" "), _c('td', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:top",
        value: ('Remove'),
        expression: "'Remove'",
        arg: "top"
      }],
      staticClass: "action",
      on: {
        "click": function($event) {
          _vm.removeFile(file)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash fa-fw",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('td', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:top",
        value: ('Copy URL'),
        expression: "'Copy URL'",
        arg: "top"
      }],
      staticClass: "action",
      on: {
        "click": function($event) {
          _vm.copyToClipboard(file)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-clipboard fa-fw",
      attrs: {
        "aria-hidden": "true"
      }
    })])])
  }))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('strong', [_vm._v("Files")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Files")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
}]}

/***/ }),
/* 271 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.modalTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Quote")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote),
      expression: "quote"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.quote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quote = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "sliceQuoteAuthor"
    }
  }, [_vm._v("Author")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.author),
      expression: "author"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "sliceQuoteAuthor"
    },
    domProps: {
      "value": (_vm.author)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.author = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "sliceQuoteStar"
    }
  }, [_vm._v("Star")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "id": "sliceQuoteStar",
      "options": ['0', '1', '2', '3', '4']
    },
    model: {
      value: (_vm.star),
      callback: function($$v) {
        _vm.star = $$v
      },
      expression: "star"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSlice.visible),
      expression: "currentSlice.visible"
    }],
    attrs: {
      "type": "checkbox",
      "id": "sliceQuoteVisible"
    },
    domProps: {
      "checked": Array.isArray(_vm.currentSlice.visible) ? _vm._i(_vm.currentSlice.visible, null) > -1 : (_vm.currentSlice.visible)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.currentSlice.visible,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.currentSlice.visible = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.currentSlice.visible = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.currentSlice, "visible", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "sliceQuoteVisible"
    }
  }, [_vm._v("Visible")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSlice.locked),
      expression: "currentSlice.locked"
    }],
    attrs: {
      "type": "checkbox",
      "id": "sliceQuoteLocked"
    },
    domProps: {
      "checked": Array.isArray(_vm.currentSlice.locked) ? _vm._i(_vm.currentSlice.locked, null) > -1 : (_vm.currentSlice.locked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.currentSlice.locked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.currentSlice.locked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.currentSlice.locked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.currentSlice, "locked", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "sliceQuoteLocked"
    }
  }, [_vm._v("Locked")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveSlice
    }
  }, [_vm._v("Save")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated-loader overlay"
  }, [_c('div', {
    staticClass: "loader",
    attrs: {
      "id": "logo-loader"
    }
  }, [_c('div', {
    staticClass: "loader-png",
    attrs: {
      "id": "logo"
    }
  }, [_c('img', {
    attrs: {
      "width": "217",
      "height": "117",
      "src": __webpack_require__(238)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "spinner-wrapper hide"
  }, [_c('div', {
    staticClass: "spinner"
  })])])
}]}

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-back container"
  }, [_c('header-back'), _vm._v(" "), _c('div', {
    staticClass: "col col-md-3"
  }, [_c('page-create')], 1), _vm._v(" "), _c('div', {
    staticClass: "col col-md-9"
  }, [_c('page-list')], 1)], 1)
},staticRenderFns: []}

/***/ })
],[168]);


// WEBPACK FOOTER //
// static/js/app.9861a9bfc339f72bda99.js